import '~/js/modules/stickyNav';
import '~/js/modules/countdown';
// import FeaturedResorts from '~/js/components/specials/home/FeaturedResorts';

// const featuredResorts = document.querySelector('#js-featured-resorts');
// const minimumRates = beaches_app.page.minimumRates;
// const offerList = beaches_app.page.offers;
// const resortPercentageOff = [...beaches_app.page.resortPercentageOff];
// const resortsSummary = beaches_app.page.resortsSummary;

// ReactDOM.render(
//   <FeaturedResorts
//     minimumRates={minimumRates}
//     offerList={offerList}
//     resortPercentageOff={resortPercentageOff}
//     resortsSummary={resortsSummary}
//     cdnURL={beaches_app.page.cdnURL}
//   />, featuredResorts
// );

/* Dynamic Specials Offers */
import Offers from '../../components/SpecialOffers/Offers';
/* eslint-disable */     
const specialsData = beaches_app.page.specialsOffersData;
console.log(specialsData);
const App = document.querySelector('#specialsOffers');

ReactDOM.render(<Offers specialOffers={specialsData} />, App);

function numberWithCommas(number) {
    var parts = number.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}

$('document').ready(() => {
    var mobileVersion = window.matchMedia("(max-width: 1024px)");
        if(mobileVersion.matches){
            timmerAlinment();
            function timmerAlinment(){
                let yellowStrip = $('#corona-virus').innerHeight();
                let menuStrip = $('.header-middle').innerHeight();
                $("#resort-menu").css("top", yellowStrip + menuStrip);
            }
            $(window).resize(function(){
                timmerAlinment();
            });
        }else{
            // $("#resort-menu").css("top", "10rem");
        }
    $('.amount > i').each(function() {
        var num = $(this).text();
        var commaNum = numberWithCommas(num);
        $(this).text(commaNum);
    });
    $('body').on('click', '.panel__label', function() { 
        if ($(this).hasClass('active')) {
            $(this)
                .siblings('.panel__inner')
                .slideUp(200);
            $(this)
                .parent()
                .removeAttr('aria-expanded', 'true')
                .attr('aria-expanded', 'false');
            $(this).removeClass('active');
        }else{
            $(this)
                .siblings('.panel__inner')
                .slideDown(200);
            $(this)
                .parent()
                .removeAttr('aria-expanded', 'false')
                .attr('aria-expanded', 'true');
            $(this).addClass('active');
        }
        
    })
    $('body').on('click', '.loadMore', function() {
        setTimeout(function(){
            $('.amount > i').each(function() {
                var num = $(this).text();
                var commaNum = numberWithCommas(num);
                $(this).text(commaNum);
            });
        }, 600);
    });
});
